import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { loadTenantsCount } from "../../app/actions"
import styled from "styled-components";
import { Button, FormControl, FormGroup, Table } from "react-bootstrap";

const Card = styled.div`
box-shadow: 0px 1px 4px #c5c5c5;
-webkit-box-shadow: 0px 1px 4px #c5c5c5;
-moz-box-shadow: 0px 1px 4px #c5c5c5;
margin-bottom: 1em;
border-radius: 4px;
background: white;
`

const CardHeader = styled.div`
padding: 20px 16px;
font-size: 1.2em;
background-color: #f1f1f1;
color: #303030;
display: flex;
`

const TenantCount = ({}) => {

    const dispatch = useDispatch()
    const tenantCount = useSelector(store => store.app.tenantsCount)
    const loadingTenantsCount = useSelector(store => store.app.loadingTenantsCount)
    const [inputs, setInputs] = useState({from: "", to: "", sortBy: "tenant_id", sortDirection: "asc"})

    const submit = () => {
        dispatch(loadTenantsCount(inputs.from, inputs.to))
    }

    const handleChange = (e) => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        })
    }

    let sortedCounts: any = [] 

    if(tenantCount && !loadingTenantsCount) {
        if(inputs.sortBy) {
            sortedCounts = [...tenantCount.counts].sort((a, b) => (inputs.sortDirection === "asc" ? 1 : -1) * (a[inputs.sortBy] === b[inputs.sortBy] ? 0 : a[inputs.sortBy] > b[inputs.sortBy] ? 1 : -1))
        } else {
            sortedCounts = tenantCount.counts
        }
    }

    return <Card>
        <CardHeader>
            <div>
                Counts per tenant
            </div>
        </CardHeader>
        <div style={{display:"flex", justifyContent:"space-between", padding: "1em"}}>
            <div style={{display:"flex", padding: "0 1em", alignItems:"flex-end"}}>
                <FormGroup>
                    <label>
                        From
                    </label>
                    <FormControl type="date" onChange={handleChange} name="from" value={inputs.from} />
                </FormGroup>
                <FormGroup>
                    <label>
                        To
                    </label>
                    <FormControl type="date" onChange={handleChange} name="to" value={inputs.to} />
                </FormGroup>
                <FormGroup>
                    <Button disabled={loadingTenantsCount} onClick={submit}>
                        Search
                    </Button>
                </FormGroup>
            </div>
            <div style={{display:"flex", padding: "0 1em"}}>
                <FormGroup>
                    <label>
                        Sort by
                    </label>
                    <FormControl custom as="select" value={inputs.sortBy} onChange={handleChange} name="sortBy">
                        <option value="tenant_id"># ID</option>
                        <option value="tenant_name">Name</option>
                        <option value="project_count">Projects</option>
                        <option value="customer_count">Customers</option>
                        <option value="variation_count">Variations</option>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <label>
                        Sort direction
                    </label>
                    <FormControl custom as="select" value={inputs.sortDirection} onChange={handleChange} name="sortDirection">
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                    </FormControl>
                </FormGroup>
            </div>
        </div>
        {tenantCount && <div style={{padding: "1em"}}>
            From: {tenantCount.from ? tenantCount.from : "-"} <i className="fa fa-arrow-right"/> To: {tenantCount.to ? tenantCount.to : "-"}
        </div>}
        <Table size={"sm"}>
            <thead>
                <th># ID</th>
                <th>Name</th>
                <th>Projects</th>
                <th>Customers</th>
                <th>Variations</th>
            </thead>
            {!loadingTenantsCount && <tbody>
                {sortedCounts.map(count => <tr>
                    <td>{count.tenant_id}</td>
                    <td>{count.tenant_name}</td>
                    <td>{count.project_count}</td>
                    <td>{count.customer_count}</td>
                    <td>{count.variation_count}</td>
                </tr>)}
                {tenantCount && <tr>
                    <td>
                        <b>Total</b>
                    </td>
                    <td>
                        <b>{sortedCounts.length}</b>
                    </td>
                    <td>
                        <b>{tenantCount.total_projects}</b>
                    </td>
                    <td>
                        <b>{tenantCount.total_customers}</b>
                    </td>
                    <td>
                        <b>{tenantCount.total_variations}</b>
                    </td>
                </tr>}
            </tbody>}
        </Table>
        {loadingTenantsCount && <div style={{padding: "1em"}}>Loading...</div>}
        
    </Card>
}

export default TenantCount